import { useAtom, useAtomValue } from 'jotai'

import { TextFieldInput, Grid, GridItem } from '@sequencehq/core-components'
import { discountAtom } from '../state.atoms'
import { RateField } from '../../../common/fields'
import { validationResultsAtom } from '../validation.atoms'
import { isFieldInvalid } from '../../../common/validation'

export type DiscountField = {
  title: string
  amount: string
}

export const DiscountField = () => {
  const [discount, updateDiscount] = useAtom(discountAtom)
  const validationResults = useAtomValue(validationResultsAtom)

  return (
    <Grid gap="8px" templateColumns="445fr 142fr">
      <GridItem>
        <TextFieldInput
          placeholder="Discount"
          value={discount.title}
          onChange={e => updateDiscount({ title: e.target.value })}
          autoFocus={!validationResults}
          isInvalid={isFieldInvalid(validationResults?.discount.title)}
        />
      </GridItem>
      <GridItem>
        <RateField
          value={discount.amount}
          onChange={amount => updateDiscount({ amount })}
          rateDisplay="ABSOLUTE"
          isInvalid={isFieldInvalid(validationResults?.discount.amount)}
        />
      </GridItem>
    </Grid>
  )
}
